<div class="modal-header justify-content-center">
    <h4 class="modal-title text-center">{{modalData?.title}}</h4>
</div>
<div class="modal-body text-center mt-3">
    <h5 *ngIf="modalData?.timer">{{counter}}</h5>
    <div class="m-0 f-s-16" [innerHTML]="modalData?.des"></div>
    <div *ngIf="modalData?.showReasonInput" class="mt-3 text-start">
        <label for="reason" class="form-label">Please provide a reason:</label>
        <textarea id="reason" class="form-control" placeholder="Enter reason" [(ngModel)]="reason" rows="2">
        </textarea>
    </div>
    
</div>
<div class="modal-footer bg-transparent border-0 pb-4 pt-0 justify-content-center">
    <button type="button" class="btn rounded btn-action"
        [ngClass]="modalData?.classConfirmButton ? modalData?.classConfirmButton : 'btn-danger'" (click)="close(1)"
        [disabled]="modalData?.showReasonInput && (!reason || !reason.trim())">
        {{modalData?.confirmButtonText ? modalData?.confirmButtonText : 'DELETE'}}
    </button>
    <div class="ml-auto">

        <button type="button" class="btn btn-primary me-2" (click)="close(2)" *ngIf="modalData?.showThiredButton">
            {{modalData?.showThiredDes ? modalData?.showThiredDes : ''}}
        </button>
        <button type="button" class="btn btn-cancel" (click)="close(0)" *ngIf="modalData?.showCancelButton">
            {{modalData?.cancelButtonText ? modalData?.cancelButtonText : 'No'}}
        </button>
    </div>
</div>